import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBX4xAS1DQsg3SG9hrQu9jATv8a3iRUjw4",
  authDomain: "lingify-website.firebaseapp.com",
  projectId: "lingify-website",
  storageBucket: "lingify-website.firebasestorage.app",
  messagingSenderId: "124020102254",
  appId: "1:124020102254:web:29cd265ac8296dd1b2c27f",
  measurementId: "G-RZ048R6NH9",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);

export default app;
